import { useState, useEffect } from 'react'

import { fetchItemPerformance } from '../services/itemPerformanceService'

function useItemPerformance(itemId, metricType) {
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!itemId || !metricType) {
      setIsLoading(false)
      return undefined
    }

    let cancelled = false

    ;(async () => {
      setIsLoading(true)
      setError(null)

      try {
        const result = await fetchItemPerformance(itemId, metricType)
        if (!cancelled) setData(result)
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Failed to load performance data')
          window.Sentry?.captureException(err)
        }
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    })()

    return () => { cancelled = true }
  }, [itemId, metricType])

  return { data, isLoading, error }
}

export default useItemPerformance
